jQuery(document).ready(function ($) {

    $('.review-slider').slick({
        infinite: false,
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1
    });

    function toNearest(num) {
        var rest = num - Math.floor(num);
        if (rest < 0.125 && Math.floor(num) != 0) {
            return Math.floor(num);
        } else {
            if (rest >= 0.875) {
                return Math.floor(num) + 1;
            } else if (rest >= 0.625) {
                return Math.floor(num) + 0.75;
            } else if (rest >= 0.375) {
                return Math.floor(num) + 0.50;
            } else {
                return Math.max(Math.floor(num), 0.25); // Round down for values less than 0.375
            }
        }
    }

    var age, weight, boxSize = "default", boxSizeMultiplier = 1;

    $('select.calc_select').on('change', function () {
        if ($(this).hasClass("age")) {
            age = $(this).val();
        } else if ($(this).hasClass("weight")) {
            weight = parseFloat($(this).val());
        } else if ($(this).hasClass("box_size")) {
            boxSize = $(this).val();
            if (boxSize === "20lbs") {
                boxSizeMultiplier = 1.6;
            }else if (boxSize === "30lbs") {
                boxSizeMultiplier = 1.6;
            } else if (boxSize === "40lbs") {
                boxSizeMultiplier = 1;
            } else {
                boxSizeMultiplier = 1; // Reset to default for other box sizes
            }
        }

        // Perform the calculation when all required inputs are defined
        if (age && weight && boxSize !== "default") {
            var food, food_lbs;

            // Calculate food in pounds based on weight and age group
            if (age == "0-3 months" || age == "0-3 mois") {
                food = (weight * 0.09) / 0.75;
                food_lbs = weight * 0.09;
            } else if (age == "3-6 months" || age == "3-6 mois") {
                food = (weight * 0.06) / 0.75;
                food_lbs = weight * 0.06;
            } else if (age == "6-8 months" || age == "6-8 mois") {
                food = (weight * 0.04) / 0.75;
                food_lbs = weight * 0.04;
            } else if (age == "8-12 months" || age == "8-12 mois") {
                food = (weight * 0.03) / 0.75;
                food_lbs = weight * 0.03;
            } else if (age == "1-8 years" || age == "1-8 ans") {
                food = (weight * 0.02) / 0.75;
                food_lbs = weight * 0.02;
            } else if (age == "8 years+" || age == "8 ans+") {
                food = (weight * 0.01) / 0.75;
                food_lbs = weight * 0.01;
            }

            if (food) {

                // Apply the box size multiplier to calculate portions
                var portions = food * boxSizeMultiplier;
                var roundedPortions = toNearest(portions); // Round portions to the nearest 0.25

                console.log("pounds => " + food_lbs.toFixed(2) + " lbs actual portions => " + portions.toFixed(2) + " Rounded Portions => " + roundedPortions);
                $(".calc_result").html(food_lbs.toFixed(2) + " lbs</br>" + roundedPortions + " Portions");
            } else {
                $(".calc_result").text("---");
            }
        } else {
            $(".calc_result").text("---");
        }
    });

    if ($("html").attr("lang") == "fr") {
        $("body").addClass("language-fr");
    }

});

$('#section-header').addClass('Header--transparent');
$(window).scroll(function () {
    if ($(this).scrollTop() > 50) {
        $('#section-header').removeClass('Header--transparent');
    } else {
        $('#section-header').addClass('Header--transparent');
    }
});

const btns = document.querySelectorAll(".acc-btn");

// fn
function accordion() {
    // this = the btn | icon & bg changed
    this.classList.toggle("is-open");

    // the acc-content
    const content = this.nextElementSibling;

    // IF open, close | else open
    if (content.style.maxHeight) content.style.maxHeight = null;
    else content.style.maxHeight = content.scrollHeight + "px";
}

// event
btns.forEach((el) => el.addEventListener("click", accordion));

/*

       Jokes are from >
        https://chartcons.com/100-funny-trick-questions-answers/
        Background image from >
        https://www.magicpattern.design/tools/css-backgrounds

*/


$(document).on('click', '.tab_block_main ul li a', function (e) {
    var curTabContentId = $(this).attr('href');
    $(this).parents('.tab_block_main').find('ul li a').removeClass('active');
    $(this).addClass('active');
    $(this).parents('.tab_block_main').find('.tab_content .tab_block').removeClass('active');
    $(curTabContentId).addClass("active");
    e.preventDefault();
});


this.reorder = new function () {
    var self = this;

    this.pushQueue = function (i, data, el) {

        //LOW STOCK -- add as many as possible if stock is below requested ammount
        if (data[i].check_inventory) {
            data[i].quantity = Math.min(parseInt(data[i].inventory), parseInt(data[i].quantity));
        }

        $.ajax({
            url: '/cart/add.js',
            method: 'POST',
            data: {
                quantity: data[i].quantity,
                id: data[i].id
            },
            complete: function (res) {
                if (i >= data.length - 1) {
                    //products from queue are now added to the cart -> stop loading signal and go to cart
                    el.removeClass('loading');
                    window.location.href = '/cart';
                    return;
                } else {
                    // Calls are async as required by Shopify Docs
                    self.pushQueue(i + 1, data, el);
                }
            }
        });
    }

    this.listen = function () {
        var el = $(this);
        var ids = el.attr('data-variant-ids').split(',');
        var quantities = el.attr('data-variant-quantities').split(',');
        var inventories = el.attr('data-variant-inventories').split(',');
        var inventory_policies = el.attr('data-variant-inventory-policies').split(',');
        var inventory_trackers = el.attr('data-variant-inventory-trackers').split(',');
        ids.splice(-1, 1);
        quantities.splice(-1, 1);
        inventories.splice(-1, 1);
        inventory_policies.splice(-1, 1);
        inventory_trackers.splice(-1, 1);

        var data = [];
        for (var i = 0; i < ids.length; i++) {
            data.push({
                id: ids[i],
                quantity: quantities[i],
                inventory: inventories[i],
                check_inventory: (inventory_policies[i] == "deny" && inventory_trackers[i] != "")
            });
        }
        el.addClass('loading');
        self.pushQueue(0, data, el);
    }

    this.init = function () {
        $('.reorder-btn').on('click', self.listen);
    }
}
$(reorder.init);

if ($("html").attr("lang") == "fr") {
    $(".canino-histoire").addClass("right-img canino-story");
}
document.addEventListener('DOMContentLoaded', function () {
    if (window.location.href.indexOf('cart') > -1) {
      // Redirect to the homepage
      window.location.href = '/';
    }
    if (document.referrer.includes("cart")) {
        document.querySelector('a[data-drawer-id="sidebar-cart"]').click()
    }
    let checkoutButton = document.querySelector('.Cart__Checkout');
    let dateBody = document.querySelector('.date_picker_body');
    let timeBody = document.querySelector('.time_picker');
    setTimeout(function () {
        let deliveryItem = document.querySelector('.Cart__Shipping-item[data-action="Delivery"]');
        if (deliveryItem) {
            deliveryItem.click();
        }
    }, 500)
    document.addEventListener('click', function (event) {
        if (event.target.matches('#applyNote')) {
            event.target.textContent = 'Applied';
            setTimeout(function () {
                document.querySelector('#editNote').style.display = 'block';
                document.querySelector('#applyNote').style.display = 'none';
            }, 800)
            event.target.textContent = 'Applied';
            window.noteField = document.querySelector('#noteField').value;
            console.log('noteField', noteField)
            $.ajax({
                url: '/cart/update.js',
                type: 'POST',
                dataType: "json",
                data: {
                    note: `${noteField}`
                },
                success: function (result) {
                    fetch('/cart.js').then(data => data.json()).then(data => console.log(data));
                }
            });
        }
        if (event.target.matches('#editNote')) {
            window.noteField = document.querySelector('#noteField').value = '';
            document.querySelector('#applyNote').textContent = 'Apply';
            document.querySelector('#applyNote').style.display = 'block';
            document.querySelector('#editNote').style.display = 'none';
        }
        if (event.target.closest('.Cart__Shipping-item')) {
            let shippingItems = document.querySelectorAll('.Cart__Shipping-item');
            shippingItems.forEach(button => {
                button.classList.remove('active')
            });
            event.target.closest('.Cart__Shipping-item').classList.add('active');
            let shippingAction = event.target.closest('.Cart__Shipping-item').getAttribute('data-action');
            let checkoutButton = document.querySelector('.Cart__Checkout');
            let shippingSearch = document.querySelector('.Cart__Shipping-search');
            let datePicker = document.querySelector('.date_picker_wrapper');
            let canadaItems = document.querySelector('.Cart__Shipping-items');
            let canadaSearch = document.getElementById('delivery-zip-canada')
               ? document.getElementById('delivery-zip-canada').closest('.Cart__Shipping-search')
               : null;

            if (shippingAction === 'Pickup') {
                datePicker.style.display = 'block';
                console.log('pickup')
                checkoutButton.setAttribute('data-disabled', 'disabled');
                timeBody.style.display = 'none';
                dateBody.style.display = 'block';
                shippingSearch.style.display = 'none';
                if (canadaSearch) {
                    canadaSearch.style.display = 'none';
                }
                $('.date_picker_month_day').text('Pick Up');
                let pickupChange = document.querySelector('.Cart__Shipping-item label');
                pickupChange.style.display = 'none';

                let canadaBlock = document.querySelector('.Cart__Shipping-item[data-action="Canada"]');
                canadaBlock.classList.add('moved');
                let id = 47932328509733;
                let quantity = 1;
                fetch('/cart/add.js', {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify({
                        id,
                        quantity
                    })
                }).then(response => response.json())
            } else if (shippingAction === 'Delivery') {
                console.log('delivery')
                let canadaBlock = document.querySelector('.Cart__Shipping-item[data-action="Canada"]');
                if (canadaBlock && canadaBlock.classList.contains('moved')) {
                    canadaBlock.classList.remove('moved');
                }
                datePicker.style.display = 'none';
                checkoutButton.setAttribute('data-disabled', 'disabled');
                checkoutButton.setAttribute('href', `/checkout`);
                shippingSearch.style.display = 'block';
                if (canadaSearch) {
                    canadaSearch.style.display = 'none';
                }
                canadaItems.style.display = 'none';
                let updates = {
                    47932328509733: 0
                };
                fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({updates})
                })
                    .then(response => {
                        return response.json();
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
            } else {
                console.log('Canada')
                shippingSearch.style.display = 'none';
                let canadaBlock = document.querySelector('.Cart__Shipping-item[data-action="Canada"]');
                if (canadaBlock && canadaBlock.classList.contains('moved')) {
                    canadaBlock.classList.remove('moved');
                }
                datePicker.style.display = 'none';

                checkoutButton.setAttribute('data-disabled', 'disabled');
                if (canadaSearch) {
                    canadaSearch.style.display = 'block';
                }
            }
        }
        if (event.target.matches('.Cart__Send-date')) {
            console.log('click');
            //order note
            let order_pickup = document.getElementsByClassName('date_picker_month_day')[0].textContent;
            console.log('order_pickup', order_pickup)
            $.ajax({
                url: '/cart/update.js',
                type: 'POST',
                dataType: "json",
                data: {
                    attributes: {
                        'PickupTime': "".concat(order_pickup)
                    }
                },
                success: function (result) {
                    fetch('/cart.js').then(data => data.json()).then(data => console.log(data));
                }
            });
        }
        if (event.target.matches('.drawer__footer-continue')) {
            console.log('continue');
            document.getElementsByClassName('Drawer__Main')[1].style.display = 'none';
            document.querySelector('.drawers__title').style.display = 'none';
            document.querySelector('.drawer__footer').style.display = 'none';
            document.querySelector('.Cart__Checkout').style.display = 'flex';
            checkoutButton.setAttribute('data-disabled', 'disabled');
            document.querySelector('.Cart__Shipping').style.display = 'block';
            document.querySelector('.drawer__steps[data-index="1"]').style.display = 'none';
            document.querySelector('.drawer__steps[data-index="2"]').style.display = 'flex';

            let stepsContainer = document.querySelector('.drawer__steps[data-index="2"]');
            if (stepsContainer) {
                let middlePosition = (stepsContainer.scrollWidth - stepsContainer.clientWidth) / 2;
                stepsContainer.scrollLeft = middlePosition;
            }
        }
        if (event.target.matches('.drawer__steps-cart')) {
            console.log('back');
            document.getElementsByClassName('Drawer__Main')[1].style.display = 'block';
            document.querySelector('.drawers__title').style.display = 'block';
            document.querySelector('.drawer__footer').style.display = 'block';
            document.querySelector('.Cart__Checkout').style.display = 'none';
            document.querySelector('.Cart__Shipping').style.display = 'none';
            document.querySelector('.date_picker_wrapper').style.display = 'none';
            document.querySelector('.drawer__steps[data-index="1"]').style.display = 'flex';
            document.querySelector('.drawer__steps[data-index="2"]').style.display = 'none';
        }
    });

    const GOOGLE_GEOCODING_API_KEY = 'AIzaSyAwyK32MDkZylG1wAoror1p-6ARE_ret7A';

    async function fetchAddressByZip(zipCode) {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(zipCode)}&language=en&key=${GOOGLE_GEOCODING_API_KEY}`;

        try {
            const response = await fetch(url);
            const data = await response.json();

            console.log('Geocoding API response:', data.status, data.error_message);

            if (data.status === 'OK' && data.results.length > 0) {
                const addressComponents = data.results[0].address_components;
                let city = '';
                let province = '';

                addressComponents.forEach(component => {
                    if (component.types.includes('locality')) {
                        city = component.long_name;
                    }
                    if (component.types.includes('administrative_area_level_1')) {
                        province = component.long_name;
                    }
                });

                return { city, province };
            } else {
                console.warn('No results from Google Geocoding API');
                return { city: '', province: '' };
            }
        } catch (error) {
            console.error('Error while fetching address data:', error);
            return { city: '', province: '' };
        }
    }

    async function fillCityProvince(zipCode) {
        if (!zipCode) return;
        const { city, province } = await fetchAddressByZip(zipCode);

        document.getElementById('klaviyoCity').value = city;
        document.getElementById('klaviyoProvince').value = province;
    }

    document.querySelector('body').addEventListener('click', async (event) => {
        if (event.target.matches('#check-delivery-btn')) {
            let checkoutButton = document.querySelector('.Cart__Checkout');
            let elem = document.querySelector('#delivery-zip');
            let eVal = elem.value;
            let valLength = eVal.length;

            let errorMessage = document.querySelector('.error-message');
            let successMessage = document.querySelector('.success-message');
            let successCheck = document.querySelector('.delivery-zip-check');

            const postalCodeRegex = /^[A-Za-z]\d[A-Za-z]\d[A-Za-z]\d$|^[A-Za-z]\d[A-Za-z]\s\d[A-Za-z]\d$/;

            if (valLength < 6 || valLength > 7 || !postalCodeRegex.test(eVal)) {
                errorMessage.textContent = "Looks like your postal code is invalid. Please correct or apply a valid Canadian format (e.g., A1A1A1 or A1A A1A)";
                errorMessage.style.display = 'block';
                checkoutButton.setAttribute('data-disabled', 'disabled');
                elem.style.border = '1px solid #BC0000';
                return;
            }

            let splitCodes = window.shippingCodes.split(',');
            let splitCodesDouble = window.shippingCodesDouble.split(',');

            let lowerCodes = splitCodes.map(function (element) {
                return element.toLowerCase().trim();
            });
            let lowerCodesDouble = splitCodesDouble.map(function (element) {
                return element.toLowerCase().trim();
            });

            if (
                lowerCodes.includes(eVal.substring(0, 3).toLowerCase()) ||
                lowerCodes.includes(eVal.toLowerCase().replace(/\s+/g, '')) ||
                lowerCodesDouble.includes(eVal.substring(0, 2).toLowerCase()) ||
                lowerCodesDouble.includes(eVal.toLowerCase().replace(/\s+/g, ''))
            ) {
                checkoutButton.setAttribute('data-disabled', 'non-disabled');
                errorMessage.style.display = 'none';
                successMessage.style.display = 'block';
                successCheck.style.display = 'block';
                elem.style.border = '1px solid darkgreen';
            } else {
                checkoutButton.setAttribute('data-disabled', 'disabled');
                successMessage.style.display = 'none';
                successCheck.style.display = 'none';

                errorMessage.textContent = "Your address is out of our range. Contact us to see if we can deliver to you!";
                errorMessage.style.display = 'block';

                document.getElementById('klaviyoName').value = '';
                document.getElementById('klaviyoEmail').value = '';
                document.getElementById('klaviyoCode').value = eVal;

                await fillCityProvince(eVal);

                document.getElementById('wrong-zip-modal').style.display = 'block';
                document.getElementById('delivery-zip').style.border = '1px solid #BC0000';
            }
        }
    });

    document.querySelector('body').addEventListener('touchstart', (event) => {
        let stepsContainer = event.target.closest('.drawer__steps');

        if (!stepsContainer) return;

        let startX = event.touches[0].pageX;
        let scrollLeft = stepsContainer.scrollLeft;

        function onTouchMove(e) {
            let moveX = e.touches[0].pageX;
            let deltaX = startX - moveX;
            stepsContainer.scrollLeft = scrollLeft + deltaX;
        }

        function onTouchEnd() {
            document.removeEventListener('touchmove', onTouchMove);
            document.removeEventListener('touchend', onTouchEnd);
        }

        document.addEventListener('touchmove', onTouchMove);
        document.addEventListener('touchend', onTouchEnd);
    });

    document.body.addEventListener('input', (event) => {
        if (event.target.matches('#delivery-zip')) {
            let errorMessage = document.querySelector('.error-message');
            let successMessage = document.querySelector('.success-message');
            let successCheck = document.querySelector('.delivery-zip-check');
            if (errorMessage) errorMessage.style.display = 'none';
            if (successMessage) successMessage.style.display = 'none';
            if (successCheck) successCheck.style.display = 'none';

            event.target.style.border = '1px solid #062D3E';
        }
    });

    document.querySelector('body').addEventListener('click', async (event) => {
        if (!event.target.matches('#check-delivery-btn-canada')) return;

        const checkoutButton = document.querySelector('.Cart__Checkout');
        const elem = document.querySelector('#delivery-zip-canada');
        const eVal = elem.value.trim();
        const valLength = eVal.length;
        const canadaItems = document.querySelector('.Cart__Shipping-items');
        const canadaCartItems = document.querySelector('.Cart__ItemListShipping');

        const successMessageCanada = document.querySelector('.success-message-canada');
        const successCheckCanada = document.querySelector('.delivery-zip-canada-check');
        const errorMessageCanada = document.querySelector('.error-message-canada');

        const lowerCodes = window.shippingCodes.split(',').map(el => el.toLowerCase().trim());
        const lowerCodesDouble = window.shippingCodesDouble.split(',').map(el => el.toLowerCase().trim());

        const validZip =
            lowerCodes.includes(eVal.substring(0, 3).toLowerCase()) ||
            lowerCodes.includes(eVal.toLowerCase().replace(/\s+/g, '')) ||
            lowerCodesDouble.includes(eVal.substring(0, 2).toLowerCase()) ||
            lowerCodesDouble.includes(eVal.toLowerCase().replace(/\s+/g, ''));

        if (valLength >= 1 && canadaCartItems && canadaCartItems.children.length > 0) {
            canadaItems.style.display = 'block';
        } else {
            canadaItems.style.display = 'none';
        }

        if (canadaItems.style.display === 'block') {
            if (validZip) {
                return;
            } else {
                checkoutButton.setAttribute('data-disabled', 'disabled');
                document.getElementById('klaviyoName').value = '';
                document.getElementById('klaviyoEmail').value = '';
                document.getElementById('klaviyoCode').value = eVal;

                await fillCityProvince(eVal);

                document.getElementById('wrong-zip-modal').style.display = 'block';
                elem.style.border = '1px solid #BC0000';
            }
        } else {
            if (validZip) {
                checkoutButton.setAttribute('data-disabled', 'non-disabled');
                elem.style.border = '1px solid darkgreen';
                if (successMessageCanada) successMessageCanada.style.display = 'block';
                if (successCheckCanada) successCheckCanada.style.display = 'block';
                if (errorMessageCanada) errorMessageCanada.style.display = 'none';
            } else {
                checkoutButton.setAttribute('data-disabled', 'disabled');
                if (valLength >= 1) {
                    document.getElementById('klaviyoName').value = '';
                    document.getElementById('klaviyoEmail').value = '';
                    document.getElementById('klaviyoCode').value = eVal;

                    await fillCityProvince(eVal);

                    document.getElementById('wrong-zip-modal').style.display = 'block';
                    elem.style.border = '1px solid #BC0000';

                    if (errorMessageCanada) errorMessageCanada.style.display = 'block';
                    if (successMessageCanada) successMessageCanada.style.display = 'none';
                    if (successCheckCanada) successCheckCanada.style.display = 'none';
                }
            }
        }
    });

    document.body.addEventListener('input', (event) => {
        if (event.target.matches('#delivery-zip-canada')) {
            const successMessageCanada = document.querySelector('.success-message-canada');
            const errorMessageCanada = document.querySelector('.error-message-canada');
            const successCheckCanada = document.querySelector('.delivery-zip-canada-check');
            if (successMessageCanada) successMessageCanada.style.display = 'none';
            if (errorMessageCanada) errorMessageCanada.style.display = 'none';
            if (successCheckCanada) successCheckCanada.style.display = 'none';

            event.target.style.border = '1px solid #062D3E';
        }
    });

    const klaviyoForm = document.getElementById('klaviyoForm');
    if (klaviyoForm) {
        klaviyoForm.addEventListener('click', function(e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }, true);

        klaviyoForm.addEventListener('focusin', function(e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }, true);
    }

    document.querySelector('.close-modal').addEventListener('click', function() {
        document.getElementById('wrong-zip-modal').style.display = 'none';
    });
    const pageOverlay = document.querySelector('.PageOverlay');
    if (pageOverlay) {
        pageOverlay.addEventListener('click', function() {
            const popup = document.getElementById('wrong-zip-modal');
            if (popup && popup.style.display !== 'none') {
                popup.style.display = 'none';
            }
        });
    }

    const zipInput = document.getElementById('klaviyoCode');
    if (zipInput) {
        zipInput.addEventListener('blur', async function() {
            const zipValue = zipInput.value.trim();
            if (!zipValue) return;
            await fillCityProvince(zipValue);
        });
    }

    document.getElementById('klaviyoForm').addEventListener('submit', function (e) {
        e.preventDefault();

        const userName = document.getElementById('klaviyoName').value.trim();
        const userEmail = document.getElementById('klaviyoEmail').value.trim();
        const userCode = document.getElementById('klaviyoCode').value.trim();
        const userCity = document.getElementById('klaviyoCity').value.trim();
        const userProvince = document.getElementById('klaviyoProvince').value.trim();

        function fillInput(selector, value) {
            const input = document.getElementById(selector);
            if (input) {
                input.value = value;

                input.dispatchEvent(new Event('input', { bubbles: true }));
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }

        function waitForKlaviyoInputs(callback) {
            const interval = setInterval(() => {
                const firstNameInput = document.getElementById('first_name_01JNEF2AK0NPTYAR44M2T68RX2');
                const emailInput = document.getElementById('email_01JNEF2AK4TA4E8MC676DVE462');

                if (firstNameInput && emailInput) {
                    clearInterval(interval);
                    callback();
                }
            }, 200);
        }

        waitForKlaviyoInputs(() => {
            fillInput('first_name_01JNEF2AK0NPTYAR44M2T68RX2', userName);
            fillInput('email_01JNEF2AK4TA4E8MC676DVE462', userEmail);
            fillInput('city_01JNEF2AK97N5Q2936Y71FBQBM', userCity);
            fillInput('Province_01JNEF2AKDQSKKJS8J6EK2NFN7', userProvince);
            fillInput('Postal_code_01JNEF2AKJZ2G5WDYW6XBSWAYE', userCode);

            setTimeout(() => {
                const submitButton = document.querySelector('.needsclick.go2534619395');
                if (submitButton) submitButton.click();
            }, 500);

            document.getElementById('wrong-zip-modal-message').style.display = 'none';
            document.getElementById('klaviyoSuccess').style.display = 'block';

            const lottieAnimation = document.querySelector('#klaviyoSuccess lottie-player');
            if (lottieAnimation) {
                lottieAnimation.stop();
                lottieAnimation.play();
            }
        });
    });


    window.addEventListener('keydown', function(event) {
        const targetId = event.target.id;
        if ((targetId === 'delivery-zip' || targetId === 'delivery-zip-canada') && event.key === 'Enter') {
            event.preventDefault();
            event.stopImmediatePropagation();

            const zipInput = document.getElementById(targetId);
            const checkButton = document.getElementById(targetId === 'delivery-zip' ? 'check-delivery-btn' : 'check-delivery-btn-canada');
            const checkoutButton = document.querySelector('.Cart__Checkout');

            checkButton.click();

            setTimeout(() => {
                if (checkoutButton && checkoutButton.getAttribute('data-disabled') !== 'disabled') {
                    checkoutButton.click();
                }
            }, 500);
        }
    }, true);

    window.addEventListener('keyup', function(event) {
        const targetId = event.target.id;
        if ((targetId === 'delivery-zip' || targetId === 'delivery-zip-canada') && event.key === 'Enter') {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }, true);

    const CONSTANTS = {
        DOM_SELECTORS: {
            datePicker: "",
            datePickerPrevMonth: ".date_picker_prev_month",
            datePickerNextMonth: ".date_picker_next_month",
            datePickerMonthDays: ".date_picker_month_days",
            datePickerMonthDay: ".date_picker_month_day",
            datePickerYear: ".date_picker_year",
            datePickerMonthName: ".date_picker_month_name",
            datePickerDay: ".day"
        },
        DOM_STRINGS: {
            dataTime: "li[data-time]"
        },
        DUMMY_LI_FOR_EMPTY_DAYS: '<li class="day"></li>',
        DAY_MAP: {
            0: "Sun",
            1: "Mon",
            2: "Tue",
            3: "Wed",
            4: "Thu",
            5: "Fri",
            6: "Sat"
        },
        MONTH_MAP: {
            0: "January",
            1: "February",
            2: "March",
            3: "April",
            4: "May",
            5: "June",
            6: "July",
            7: "August",
            8: "September",
            9: "October",
            10: "November",
            11: "December"
        }
    };

    const utils = (function () {
        function prefixDOMSelectorsWithPickerSelector(pickerSelector) {
            let DOM_SELECTORS = {};
            for (let selector in CONSTANTS.DOM_SELECTORS) {
                DOM_SELECTORS[
                    selector
                    ] = `${pickerSelector} ${CONSTANTS.DOM_SELECTORS[selector]}`.trim();
            }
            CONSTANTS.DOM_SELECTORS = DOM_SELECTORS;
        }

        function getDOMElements(DOMSelectors) {
            let DOMElements = {};
            for (let selector in DOMSelectors) {
                if (DOMSelectors.hasOwnProperty(selector)) {
                    DOMElements[selector] = document.querySelector(DOMSelectors[selector]);
                }
            }
            return DOMElements;
        }

        function getDatePickerWeekDaysNameMarkUp() {
            return `
        <li>Sun</li>
        <li>Mon</li>
        <li>Tue</li>
        <li>Wed</li>
        <li>Thu</li>
        <li>Fri</li>
        <li>Sat</li>`;
        }

        function getDayMarkup(day = 1, isActive = false, time = null, dayOfWeek, currentStringDate, currentMonth, currentYear) {
            if (!time) {
                console.trace(`The time provided for getDayMarkup ${time} is invalid`);
            }
            let now = new Date();
            // let dayOfMonth = time.getDay();
            let dayOfMonth = time;
            now.setHours(0, 0, 0, 0);

            let stringDate = `${now.getDate()}/${now.getMonth() + 1}/${now.getFullYear()}`;

            let checkCurrentDate = `${currentMonth + 1}/${day}/${currentYear}`;

            if (time < now || dayOfWeek === 0 || dayOfWeek === 1 || currentStringDate === stringDate) {
                return `
            <li class="day passed" data-time="${time}" data-day="${dayOfWeek}" data-date="${day}" data-month="${currentMonth + 1}" data-year="${currentYear}">
                <button class="${isActive ? "active" : ""}">${day}</button>
            </li>`;
            } else {
                return `
            <li class="day" data-time="${time}" data-day="${dayOfWeek}" data-date="${day}" data-month="${currentMonth + 1}" data-year="${currentYear}">
                <button class="${isActive ? "active" : ""}">${day}</button>
            </li>`;
            }
        }

        function getAllDays() {
            let days = document.querySelectorAll(CONSTANTS.DOM_SELECTORS.datePickerDay);
            return [...(days ?? [])];
        }

        function getDaySuffix(day) {
            switch (day) {
                case 1:
                case 21:
                case 31:
                    return "st";
                case 2:
                case 22:
                    return "nd";
                case 3:
                case 23:
                    return "rd";
                default:
                    return "th";
            }
        }

        return {
            prefixDOMSelectorsWithPickerSelector,
            getDOMElements,
            getDatePickerWeekDaysNameMarkUp,
            getDayMarkup,
            getAllDays,
            getDaySuffix
        };
    })();

    const model = (function () {
        const data = {
            currentDate: new Date(),
            selectedDate: new Date()
        };

        function setCurrentDate(newDate) {
            data.currentDate = newDate;
        }

        function setSelectedDate(newDate) {
            data.selectedDate = newDate;
        }

        function getCurrentDate() {
            return data.currentDate;
        }

        function getSelectedDate() {
            return data.selectedDate;
        }

        return {setCurrentDate, setSelectedDate, getCurrentDate, getSelectedDate};
    })();

    const view = (function (model, utils) {
        function removeDays() {
            const allDays = utils.getAllDays();
            allDays.forEach((day) => day.remove());
        }

        function fillEmptyDays(count) {
            const DOMElements = utils.getDOMElements(CONSTANTS.DOM_SELECTORS);
            for (let i = 0; i < count; i++) {
                DOMElements.datePickerMonthDays.insertAdjacentHTML(
                    "beforeend",
                    CONSTANTS.DUMMY_LI_FOR_EMPTY_DAYS
                );
            }
        }

        function fillDay(day, isActive = false, time, dayOfWeek, currentStringDate, currentMonth, currentYear) {
            const dayMarkUp = utils.getDayMarkup(day, isActive, time, dayOfWeek, currentStringDate, currentMonth, currentYear);
            const DOMElements = utils.getDOMElements(CONSTANTS.DOM_SELECTORS);
            DOMElements.datePickerMonthDays.insertAdjacentHTML("beforeend", dayMarkUp);
        }

        function fillCurrentMonth(string) {
            const DOMElements = utils.getDOMElements(CONSTANTS.DOM_SELECTORS);
            DOMElements.datePickerMonthName.textContent = string;
        }

        function fillSelectedDate(month, date, day, year) {
            const DOMElements = utils.getDOMElements(CONSTANTS.DOM_SELECTORS);
            DOMElements.datePickerMonthDay.innerHTML = `Pickup Date: ${CONSTANTS.MONTH_MAP[month]} ${date}<sup>${utils.getDaySuffix(date)}</sup>, ${CONSTANTS.DAY_MAP[day]}`;
            DOMElements.datePickerYear.textContent = year;
            $('.time').removeClass('active');
            let checkoutButton = document.querySelector('.Cart__Checkout');
            $('.time').click(function () {
                $('.time').removeClass('active');
                $(this).addClass('active');
                let time_slot = $(this).text();
                $('.date_picker_month_day').text(`Pickup Date: ${date} ${CONSTANTS.MONTH_MAP[month]}, ${year}, ${time_slot}`);
                let datePicker = document.querySelector('.date_picker_wrapper');
                datePicker.style.display = 'none';
                console.log('open')
                checkoutButton.setAttribute('data-disabled', 'non-disabled');
                checkoutButton.setAttribute('href', `/checkout?step=contact_information&checkout[shipping_address][company]=Canino Pet Supply Store&checkout[shipping_address][address1]=376 Beaumont Ave&checkout[shipping_address][city]=Montréal&checkout[shipping_address][country]=Canada&checkout[shipping_address][zip]=H3N 1T4&checkout[shipping_address][province]=Quebec&skip_shopify_pay=true&locale=en-pickup`);
            })
        }

        return {
            removeDays,
            fillEmptyDays,
            fillDay,
            fillCurrentMonth,
            fillSelectedDate
        };
    })(model, utils);

    const controller = (function (model, view, utils) {
        let DOMElements = null;

        function init(pickerSelector = "", selectedDate = new Date()) {
            utils.prefixDOMSelectorsWithPickerSelector(pickerSelector);
            DOMElements = utils.getDOMElements(CONSTANTS.DOM_SELECTORS);
            if (!DOMElements.datePicker) {
                throw new Error(
                    `Date Picker with selector ${pickerSelector} not found in the document`
                );
            }
            DOMElements.datePickerNextMonth.addEventListener("click", function (e) {
                e.preventDefault();
                handleNextMonthClick(e);
            });
            DOMElements.datePickerPrevMonth.addEventListener("click", function (e) {
                e.preventDefault();
                handlePrevMonthClick(e);
            });
            DOMElements.datePickerMonthDays.addEventListener("click", handleSelectDate);
            if (selectedDate.constructor !== Date) {
                throw new Error(`The initial date ${selectedDate} is not a Date Object`);
            }
            let clonedSelectedDate = new Date(selectedDate.getTime());
            let clonedCurrentDate = new Date(selectedDate.getTime());
            model.setSelectedDate(clonedSelectedDate);
            model.setCurrentDate(clonedCurrentDate);
            render(selectedDate);
        }

        function handleSelectDate(event) {
            const time = event.target.closest(CONSTANTS.DOM_STRINGS.dataTime)?.dataset
                .time;
            if (!time) return;
            model.setSelectedDate(new Date(Number(time)));
            model.setCurrentDate(new Date(Number(time)));
            render();
        }

        function handleNextMonthClick() {
            render();
        }

        function handlePrevMonthClick() {
            let currentDate = new Date(model.getCurrentDate().getTime());
            currentDate.setMonth(currentDate.getMonth() - 2);
            model.setCurrentDate(currentDate);
            render();
        }

        function render(selectedDate = null) {
            updateSelectedDateMarkUp();
            view.removeDays();
            let currentDate = new Date(
                selectedDate?.getTime() ?? model.getCurrentDate().getTime()
            );
            let selected = model.getSelectedDate();
            let selectedDay = selected.getDate();
            let selectedMonth = selected.getMonth();
            let selectedYear = selected.getFullYear();
            currentDate.setDate(1);
            let renderingMonth = currentDate.getMonth();
            view.fillEmptyDays(currentDate.getDay());
            view.fillCurrentMonth(
                `${CONSTANTS.MONTH_MAP[renderingMonth]} - ${currentDate.getFullYear()}`
            );
            while (currentDate.getMonth() === renderingMonth) {
                let currentMonth = currentDate.getMonth();
                let currentDay = currentDate.getDate();
                let currentDayOfWeek = currentDate.getDay();
                let currentYear = currentDate.getFullYear();
                let currentStringDate = `${currentDay}/${
                    currentMonth + 1
                }/${currentYear}`;
                let selectedStringDate = `${selectedDay}/${
                    selectedMonth + 1
                }/${selectedYear}`;
                view.fillDay(
                    currentDate.getDate(),
                    selectedStringDate === currentStringDate,
                    currentDate.getTime(),
                    currentDayOfWeek,
                    currentStringDate,
                    currentMonth,
                    currentYear
                );
                currentDate.setDate(currentDay + 1);
            }
            model.setCurrentDate(currentDate);

            $('.day').click(function () {
                console.log('day')
                dateBody.style.display = 'none';
                timeBody.style.display = 'block';
                let pickupChange = document.querySelector('.Cart__Shipping-item label');
                pickupChange.style.display = 'block';
            })
        }

        function updateSelectedDateMarkUp() {
            const currentDate = new Date(model.getSelectedDate().getTime());
            view.fillSelectedDate(
                currentDate.getMonth(),
                currentDate.getDate(),
                currentDate.getDay(),
                currentDate.getFullYear()
            );
        }

        return {init};
    })(model, view, utils);

    controller.init("#date_picker_1");
})